export default __webpack_public_path__ + "images/metal1-1024-q3-e8350efa015f79336a703f38ba85a6d1.jpg";